import { Component, inject } from '@angular/core';

import { AlertComponent } from './alert/alert.component';

import { PageMessagesService } from './page-messages.service';

@Component({
  imports: [AlertComponent],
  selector: 'ideals-page-message',
  styleUrl: './page-messages.component.scss',
  templateUrl: './page-messages.component.html',
})
export class PageMessagesComponent {
  readonly #pageMessages = inject(PageMessagesService);

  readonly messages = this.#pageMessages.messages;
}
